require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-powering-jamaicas-digital-transformation.json") })
        }
      }, "path---blog-powering-jamaicas-digital-transformation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-powering-jamaicas-digital-transformation!./.cache/json/blog-powering-jamaicas-digital-transformation.json
// module id = 1044
// module chunks = 231608221292675